module.exports = __webpack_public_path__ + "static/media/red-roman.afc5f880.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/fish/red-roman.png
// module id = 332
// module chunks = 0